import { render, staticRenderFns } from "./Ccliente.vue?vue&type=template&id=3febcc6a&"
import script from "./Ccliente.vue?vue&type=script&lang=js&"
export * from "./Ccliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports